export default __webpack_public_path__ + "static/media/unsere-3.0fa58709.jpg";